import { computed, resolveComponent, createBlock, openBlock, withCtx, createVNode, createTextVNode, toDisplayString, normalizeProps, guardReactiveProps } from "vue";
import { isNumber } from "lodash-es";
import { VCard, VCardTitle, VCardText } from "vuetify/components/VCard";
import { VDivider } from "vuetify/components/VDivider";
import { VIcon } from "vuetify/components/VIcon";
import { VListSubheader, VListItem, VListItemTitle } from "vuetify/components/VList";
import { VMenu } from "vuetify/components/VMenu";
const _sfc_main = {
  __name: "NumberFilterItem",
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "lets-icons:chart-duotone"
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emits = __emit;
    const props = __props;
    const fromValue = computed({
      get: () => {
        var _a;
        return (_a = props.modelValue) == null ? void 0 : _a[0];
      },
      set: (value) => {
        var _a, _b;
        emits(
          "update:modelValue",
          !isNumber(value) && !isNumber((_a = props.modelValue) == null ? void 0 : _a[1]) ? [] : [value, (_b = props.modelValue) == null ? void 0 : _b[1]]
        );
      }
    });
    const toValue = computed({
      get: () => {
        var _a;
        return (_a = props.modelValue) == null ? void 0 : _a[1];
      },
      set: (value) => {
        var _a, _b;
        emits(
          "update:modelValue",
          !isNumber(value) && !isNumber((_a = props.modelValue) == null ? void 0 : _a[0]) ? [] : [(_b = props.modelValue) == null ? void 0 : _b[0], value]
        );
      }
    });
    return (_ctx, _cache) => {
      const _component_b_icon = resolveComponent("b-icon");
      const _component_b_text_edit = resolveComponent("b-text-edit");
      return openBlock(), createBlock(VMenu, {
        width: "350",
        offset: "8",
        class: "banza-boolean-filter-item",
        "close-on-content-click": false,
        location: "end"
      }, {
        activator: withCtx(({ props: activatorProps }) => [
          createVNode(VListItem, normalizeProps(guardReactiveProps(activatorProps)), {
            prepend: withCtx(() => [
              createVNode(_component_b_icon, {
                size: "20",
                class: "mr-2",
                icon: __props.icon
              }, null, 8, ["icon"])
            ]),
            append: withCtx(() => [
              createVNode(VIcon, null, {
                default: withCtx(() => _cache[2] || (_cache[2] = [
                  createTextVNode("mdi-chevron-right")
                ])),
                _: 1,
                __: [2]
              })
            ]),
            default: withCtx(() => [
              createVNode(VListItemTitle, null, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(__props.label), 1)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040)
        ]),
        default: withCtx(() => [
          createVNode(VCard, { class: "rounded-lg banza-lookup-filter-card" }, {
            default: withCtx(() => [
              createVNode(VCardTitle, { class: "pa-0" }, {
                default: withCtx(() => [
                  createVNode(VListSubheader, { class: "banza-filter--header py-3 pl-3" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.label), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(VDivider)
                ]),
                _: 1
              }),
              createVNode(VCardText, { class: "d-flex pa-2 ga-2 flex-nowrap" }, {
                default: withCtx(() => [
                  createVNode(_component_b_text_edit, {
                    modelValue: fromValue.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => fromValue.value = $event),
                    type: "number",
                    label: _ctx.$t("base.from")
                  }, null, 8, ["modelValue", "label"]),
                  createVNode(_component_b_text_edit, {
                    modelValue: toValue.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => toValue.value = $event),
                    type: "number",
                    label: _ctx.$t("base.to")
                  }, null, 8, ["modelValue", "label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
